module.exports = __webpack_public_path__ + "tj.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/tj.svg
// module id = 1095
// module chunks = 0